<template>
  <div>
  <a-tabs v-model="activeTab">
    <a-tab-pane key="list" tab="模板列表">
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :bordered="false">
        <!-- 搜索栏 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="模板名称">
                  <a-input v-model="query.templateName" placeholder="请输入模板名称" allowClear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="单据类型">
                  <a-select v-model="query.billType" placeholder="请选择" allowClear style="width: 100%">
                    <a-select-option value="purchase_apply">请购单</a-select-option>
                    <a-select-option value="purchase_order">采购订单</a-select-option>
                    <a-select-option value="purchase_in">采购入库</a-select-option>
                    <a-select-option value="sales_order">销售订单</a-select-option>
                    <a-select-option value="sales_out">销售出库</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="状态">
                  <a-select v-model="query.enabled" placeholder="全部" allowClear style="width: 100%">
                    <a-select-option :value="1">启用</a-select-option>
                    <a-select-option :value="0">禁用</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <span style="float: left; overflow: hidden;">
                <a-col :md="12" :sm="24">
                  <a-button type="primary" icon="search" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" icon="reload" @click="searchReset">重置</a-button>
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>

        <!-- 操作栏 - 根据 push_btn 配置显示按钮 -->
        <!-- push_btn 配置: 1=编辑(增/改/删), 2=审核, 3=导出, 4=启用禁用, 5=打印, 6=作废, 7=反审核 -->
        <div class="table-operator" style="margin-top: 10px">
          <a-button v-if="hasBtn(1)" type="primary" icon="plus" @click="handleAdd">新增模板</a-button>
          <a-button v-if="hasBtn(1)" icon="upload" @click="handleBatchImport">从文件导入模板</a-button>
          <a-button v-if="hasBtn(1)" icon="edit" :disabled="selectedRowKeys.length === 0" @click="handleBatchEdit">批量编辑</a-button>
          <a-button v-if="hasBtn(1)" icon="delete" :disabled="selectedRowKeys.length === 0" @click="handleBatchDelete">批量删除</a-button>
          <a-button v-if="hasBtn(3)" icon="download" @click="handleExport">导出</a-button>
        </div>

        <!-- 模板表格 -->
        <a-table
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :rowKey="(record) => record.id"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          @change="handleTableChange">
          
          <!-- 单据类型插槽 -->
          <template slot="billType" slot-scope="text">
            <a-tag :color="getBillTypeColor(text)">{{ getBillTypeName(text) }}</a-tag>
          </template>
          
          <!-- 状态插槽 -->
          <template slot="enabled" slot-scope="text, record">
            <a-switch
              :checked="text === 1"
              :disabled="!hasBtn(4)"
              @change="(checked) => handleToggle(record, checked)">
            </a-switch>
          </template>
          
          <!-- 默认标记插槽 -->
          <template slot="isDefault" slot-scope="text">
            <a-icon v-if="text === 1" type="star" theme="filled" style="color: #faad14" />
            <span v-else style="color: #bbb">-</span>
          </template>
          
          <!-- 创建时间插槽 -->
          <template slot="createTime" slot-scope="text">
            {{ formatDateTime(text) }}
          </template>
          
          <!-- 操作插槽 -->
          <template slot="action" slot-scope="text, record">
            <a @click="handleDesign(record)">设计</a>
            <a-divider v-if="hasBtn(1)" type="vertical" />
            <a @click="handlePreview(record)">预览</a>
            <a-divider v-if="hasBtn(5)" type="vertical" />
            <a-dropdown v-if="hasBtn(1) || hasBtn(4) || hasBtn(6)">
              <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
              <a-menu slot="overlay">
                <a-menu-item v-if="record.isDefault !== 1 && hasBtn(4)" @click="handleSetDefault(record)">
                  设为默认
                </a-menu-item>
                <a-menu-item v-if="hasBtn(1)" @click="handleCopy(record)">
                  复制模板
                </a-menu-item>
                <a-menu-divider />
                <a-menu-item v-if="hasBtn(6)" @click="handleVoid(record)">
                  作废
                </a-menu-item>
                <a-menu-item v-if="hasBtn(1)" @click="handleDelete(record)" style="color: #ff4d4f">
                  删除
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </template>
        </a-table>
      </a-card>
    </a-col>
  </a-row>

  <!-- 导入结果弹窗 -->
  <a-modal
    title="批量导入结果"
    :visible="importResultVisible"
    @ok="importResultVisible = false"
    @cancel="importResultVisible = false"
    :footer="null"
    width="600px"
  >
    <a-alert 
      :message="`导入完成：成功 ${importResult.success} 个，失败 ${importResult.fail} 个`"
      :description="`总文件数: ${importResult.totalFiles}，目录: ${importResult.directory}`"
      :type="importResult.fail > 0 ? 'warning' : 'success'"
      show-icon
      style="margin-bottom: 16px;"
    />
    
    <!-- 成功列表 -->
    <div v-if="importResult.successFiles.length > 0" style="margin-bottom: 12px;">
      <h4 style="color: #52c41a; margin: 8px 0;">成功导入 ({{ importResult.successFiles.length }})</h4>
      <ul style="list-style: none; padding: 0; max-height: 150px; overflow-y: auto;">
        <li v-for="(file, index) in importResult.successFiles" :key="'success-' + index" style="padding: 2px 0; color: #389e0d;">
          ✓ {{ file }}
        </li>
      </ul>
    </div>
    
    <!-- 失败列表 -->
    <div v-if="importResult.failFiles.length > 0">
      <h4 style="color: #ff4d4f; margin: 8px 0;">失败 ({{ importResult.failFiles.length }})</h4>
      <ul style="list-style: none; padding: 0; max-height: 150px; overflow-y: auto;">
        <li v-for="(file, index) in importResult.failFiles" :key="'fail-' + index" style="padding: 2px 0; color: #cf1322;">
          ✗ {{ file }}
        </li>
      </ul>
    </div>
    
    <div style="text-align: right; margin-top: 16px;">
      <a-button type="primary" @click="importResultVisible = false">确定</a-button>
    </div>
  </a-modal>
    </a-tab-pane>
    <a-tab-pane key="designer" tab="模板设计">
      <TemplateDesignerV2
        v-if="designerVisible"
        :template-id="currentDesignerId"
        :bill-type="currentDesignerBillType"
        @close="handleDesignerClose"
        @saved="handleDesignerSaved"
      />
    </a-tab-pane>
  </a-tabs>
  </div>
</template>

<script>
import { getList, deleteTemplate, toggleTemplate, setDefaultTemplate, copyTemplate, importTemplatesFromFiles } from '@/api/plugin/print-template'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import Vue from 'vue'
import TemplateDesignerV2 from './TemplateDesignerV2.vue'

export default {
  name: 'TemplateList',
  components: { TemplateDesignerV2 },
  data() {
    return {
      activeTab: 'list',
      designerVisible: false,
      currentDesignerId: null,
      currentDesignerBillType: '',
      // 数据源
      dataSource: [],
      // 表格加载状态
      loading: false,
      // 选中的行
      selectedRowKeys: [],
      selectedRows: [],
      // 分页参数
      ipagination: {
        current: 1,
        pageSize: 20,
        pageSizeOptions: ['10', '20', '30', '50', '100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      // 查询参数
      query: {
        templateName: '',
        billType: '',
        enabled: null
      },
      // 按钮权限列表 (push_btn 配置: 1=编辑, 2=审核, 3=导出, 4=启用禁用, 5=打印, 6=作废, 7=反审核)
      btnEnableList: [1, 2, 3, 4, 5, 6, 7], // 默认所有按钮可用
      // 导入结果弹窗
      importResultVisible: false,
      importResult: {
        success: 0,
        fail: 0,
        successFiles: [],
        failFiles: [],
        totalFiles: 0,
        directory: ''
      },
      // 导入路径（可配置）
      importDirectory: 'D:\\JSH_ERP\\辅助资料\\打印模板',
      // 完整的14种单据类型
      fullBillTypeList: [
        { value: 'purchase_apply', label: '请购单' },
        { value: 'purchase_order', label: '采购订单' },
        { value: 'purchase_in', label: '采购入库' },
        { value: 'purchase_return', label: '采购退货' },
        { value: 'sales_order', label: '销售订单' },
        { value: 'sales_out', label: '销售出库' },
        { value: 'sales_return', label: '销售退货' },
        { value: 'retail_out', label: '零售出库' },
        { value: 'retail_return', label: '零售退货' },
        { value: 'other_in', label: '其它入库' },
        { value: 'other_out', label: '其它出库' },
        { value: 'assemble', label: '组装单' },
        { value: 'disassemble', label: '拆卸单' },
        { value: 'transfer_out', label: '调拔出库' }
      ],
      // 表格列定义
      columns: [
        { title: 'ID', dataIndex: 'id', width: 60 },
        { title: '模板名称', dataIndex: 'templateName', width: 150 },
        { title: '单据类型', dataIndex: 'billType', width: 100, scopedSlots: { customRender: 'billType' } },
        { title: '纸张', dataIndex: 'paperType', width: 80 },
        { title: '默认', dataIndex: 'isDefault', width: 60, align: 'center', scopedSlots: { customRender: 'isDefault' } },
        { title: '启用', dataIndex: 'enabled', width: 100, scopedSlots: { customRender: 'enabled' } },
        { title: '创建时间', dataIndex: 'createTime', width: 160, scopedSlots: { customRender: 'createTime' } },
        { title: '操作', dataIndex: 'action', width: 250, scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  created() {
    // 初始化按钮权限
    this.initBtnPermissions()
    // 加载数据
    this.loadData()
  },
  methods: {
    // 初始化按钮权限 - 根据数据库配置的 push_btn 决定哪些按钮可用
    initBtnPermissions() {
      let btnStrList = Vue.ls.get('winBtnStrList')
      this.btnEnableList = [1, 2, 3, 4, 5, 6, 7]
      
      if (btnStrList && btnStrList.length > 0) {
        let urlPath = '/print-template/list'
        let found = false
        for (let i = 0; i < btnStrList.length; i++) {
          if (btnStrList[i].url === urlPath || btnStrList[i].url && btnStrList[i].url.indexOf('/print-template') >= 0) {
            if (btnStrList[i].btnStr) {
              this.btnEnableList = btnStrList[i].btnStr.split(',').map(item => parseInt(item))
            } else {
              this.btnEnableList = []
            }
            found = true
            break
          }
        }
        if (!found) {
          this.btnEnableList = [1, 2, 3, 4, 5, 6, 7]
        }
      }
    },
    // 检查某个按钮是否可用
    hasBtn(btnId) {
      return this.btnEnableList.includes(btnId)
    },
    // 获取查询参数
    getQueryParams() {
      let params = {}
      if (this.query.templateName) params.templateName = this.query.templateName
      if (this.query.billType) params.billType = this.query.billType
      if (this.query.enabled !== null && this.query.enabled !== '') params.enabled = this.query.enabled
      params.page = this.ipagination.current
      params.size = this.ipagination.pageSize
      return params
    },
    // 加载数据
    loadData() {
      let params = this.getQueryParams()
      this.loading = true
      console.log('Loading data with params:', params)
      getList(params).then(res => {
        console.log('API Response:', res)
        if (res.code === 200) {
          // 后端返回的是 list 或 rows
          this.dataSource = res.data.list || res.data.rows || []
          this.ipagination.total = res.data.total || 0
        } else {
          this.$message.error(res.msg || res.message || '加载数据失败')
        }
      }).catch((err) => {
        console.error('加载数据失败:', err)
        this.$message.error('加载数据失败')
      }).finally(() => {
        this.loading = false
      })
    },
    // 查询
    searchQuery() {
      this.ipagination.current = 1
      this.loadData()
    },
    // 重置
    searchReset() {
      this.query = { templateName: '', billType: '', enabled: null }
      this.searchQuery()
    },
    // 表格变化
    handleTableChange(pagination) {
      this.ipagination.current = pagination.current
      this.ipagination.pageSize = pagination.pageSize
      this.loadData()
    },
    // 选择行
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    // 新增
    handleAdd() {
      this.currentDesignerId = null
      this.currentDesignerBillType = ''
      this.designerVisible = true
      this.activeTab = 'designer'
    },
    // 设计
    handleDesign(record) {
      this.currentDesignerId = record.id
      this.currentDesignerBillType = record.billType || ''
      this.designerVisible = true
      this.activeTab = 'designer'
    },
    // 设计器关闭
    handleDesignerClose() {
      this.designerVisible = false
      this.activeTab = 'list'
    },
    // 设计器保存
    handleDesignerSaved() {
      this.designerVisible = false
      this.activeTab = 'list'
      this.loadData()
    },
    // 预览
    handlePreview(record) {
      const url = '/print-template/preview/' + record.id
      const routeData = this.$router.resolve(url)
      window.open(routeData.href, '_blank', 'width=1024,height=768')
    },
    // 启用/禁用
    handleToggle(record, checked) {
      toggleTemplate(record.id, checked ? 1 : 0).then(() => {
        this.$message.success(checked ? '已启用' : '已禁用')
        this.loadData()
      }).catch(() => {
        this.$message.error('操作失败')
      })
    },
    // 设为默认
    handleSetDefault(record) {
      setDefaultTemplate(record.id).then(() => {
        this.$message.success('已设为默认模板')
        this.loadData()
      }).catch(() => {
        this.$message.error('操作失败')
      })
    },
    // 复制
    handleCopy(record) {
      copyTemplate(record.id).then(res => {
        if (res.code === 200) {
          this.$message.success('复制成功')
          this.loadData()
        } else {
          this.$message.error(res.msg || '复制失败')
        }
      }).catch(() => {
        this.$message.error('复制失败')
      })
    },
    // 删除
    handleDelete(record) {
      this.$confirm({
        title: '确认删除',
        content: '确定要删除模板 "' + record.templateName + '" 吗？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          return deleteTemplate(record.id)
        }
      }).then(() => {
        this.$message.success('删除成功')
        this.loadData()
      }).catch(() => {})
    },
    // 批量编辑
    handleBatchEdit() {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请先选择要编辑的记录')
        return
      }
      this.$message.info('批量编辑功能开发中...')
    },
    // 批量删除
    handleBatchDelete() {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请先选择要删除的记录')
        return
      }
      this.$confirm({
        title: '确认删除',
        content: '确定要删除选中的 ' + this.selectedRowKeys.length + ' 条记录吗？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          this.$message.success('批量删除成功')
          this.loadData()
        }
      })
    },
    // 导出
    handleExport() {
      this.$message.info('导出功能开发中...')
    },
    // 作废
    handleVoid(record) {
      this.$confirm({
        title: '确认作废',
        content: '确定要作废模板 "' + record.templateName + '" 吗？',
        okText: '确定',
        okType: 'warning',
        cancelText: '取消',
        onOk: () => {
          this.$message.success('作废成功')
          this.loadData()
        }
      })
    },
    // 单据类型名称（完整14种）
    getBillTypeName(code) {
      const nameMap = {
        'purchase_apply': '请购单',
        'purchase_order': '采购订单',
        'purchase_in': '采购入库',
        'purchase_return': '采购退货',
        'sales_order': '销售订单',
        'sales_out': '销售出库',
        'sales_return': '销售退货',
        'retail_out': '零售出库',
        'retail_return': '零售退货',
        'other_in': '其它入库',
        'other_out': '其它出库',
        'assemble': '组装单',
        'disassemble': '拆卸单',
        'transfer_out': '调拔出库'
      }
      return nameMap[code] || code
    },
    // 单据类型颜色（完整14种）
    getBillTypeColor(code) {
      const colorMap = {
        'purchase_apply': 'blue',
        'purchase_order': 'cyan',
        'purchase_in': 'green',
        'purchase_return': 'geekblue',
        'sales_order': 'orange',
        'sales_out': 'red',
        'sales_return': 'volcano',
        'retail_out': 'gold',
        'retail_return': 'lime',
        'other_in': 'purple',
        'other_out': 'magenta',
        'assemble': 'blue',
        'disassemble': 'cyan',
        'transfer_out': 'green'
      }
      return colorMap[code] || 'default'
    },
    // 批量导入模板
    handleBatchImport() {
      this.$confirm({
        title: '确认批量导入',
        content: `将从以下目录导入所有模板文件：\n${this.importDirectory}\n\n已存在的模板将被更新，是否继续？`,
        okText: '开始导入',
        cancelText: '取消',
        onOk: async () => {
          try {
            this.loading = true
            const res = await importTemplatesFromFiles({ directory: this.importDirectory })
            
            if (res.code === 200) {
              this.importResult = res.data
              this.importResultVisible = true
              this.loadData()
              this.$message.success(res.msg || '导入完成')
            } else {
              this.$message.error(res.msg || '导入失败')
            }
          } catch (error) {
            console.error('导入失败:', error)
            this.$message.error('导入异常，请检查后端服务是否正常')
          } finally {
            this.loading = false
          }
        }
      })
    },
    // 单据类型标签
    getBillTypeTag(text) {
      const h = this.$createElement
      return h('a-tag', { props: { color: this.getBillTypeColor(text) } }, this.getBillTypeName(text))
    },
    // 默认图标
    getDefaultIcon(text) {
      const h = this.$createElement
      if (text === 1) {
        return h('a-icon', { props: { type: 'star', theme: 'filled', style: 'color: #faad14' } })
      }
      return h('span', { style: 'color: #bbb' }, '-')
    },
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '-'
      const h = this.$createElement
      let date = new Date(dateStr)
      if (isNaN(date.getTime())) return dateStr
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return h('span', {}, `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`)
    },
    // 格式化日期时间为字符串
    formatDateTime(dateStr) {
      if (!dateStr) return '-'
      let date = new Date(dateStr)
      if (isNaN(date.getTime())) return dateStr
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}
.table-operator {
  margin-bottom: 16px;
}
</style>
